<template>
    <div class="page dictionaryPage">
        <!--<h3 class="page-title">字典管理</h3>-->

        <el-tabs type="border-card" @tab-click="handleClick">

            <div class="page-operate">
                <el-button-group>
                    <el-tooltip class="item" effect="dark" :content="$t('c.add')" placement="top-start" :hide-after="1000">
                        <el-button type="primary" size="small" @click="handleAdd()">
                            <i class="nucfont inuc-add"></i>
                        </el-button>
                    </el-tooltip>
                </el-button-group>
            </div>

            <el-tab-pane :label="$t('c.operatorLevel')">

                <data-tables class="form-table"
                        :data="levelTableData"
                        :table-props="tableProps"
                        :page-size="20"
                        :pagination-props="{pageSizes: [20, 50, 100, 300, 500]}"
                >
                    <el-table-column type="index" width="50" align="center">
                    </el-table-column>
                    <!-- column title -->
                    <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label" :key="title.label"
                            align="center"
                            sortable="custom">
                    </el-table-column>

                    <!-- column buttons -->
                    <el-table-column :label="$t('c.operation')" align="center">
                        <div class="btn-cell" slot-scope="scope">
                            <i class="nucfont inuc-edit"
                                :title="$t('c.edit')"
                                @click="handleEdit(scope.row.id,0,1)"></i>
                            <i class="nucfont inuc-delete"
                                :title="$t('c.delete')"
                                @click="handleDelete(scope.row.id,0,1)"></i>
                        </div>
                    </el-table-column>
                </data-tables>
            </el-tab-pane>

            <el-tab-pane :label="$t('c.examType')">

                <data-tables class="form-table"
                        :data="testTableData"
                        :table-props="tableProps"
                        :page-size="20"
                        :pagination-props="{pageSizes: [20, 50, 100, 300, 500]}"
                >
                    <el-table-column type="index" width="50" align="center"></el-table-column>

                    <!-- column title -->
                    <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label" :key="title.label"
                            align="center"
                            sortable="custom">
                    </el-table-column>

                    <!-- column buttons -->

                    <el-table-column :label="$t('c.operation')" align="center">
                        <div class="btn-cell" slot-scope="scope">
                            <i class="nucfont inuc-edit"
                                :title="$t('c.edit')"
                                @click="handleEdit(scope.row.id,0,1)"></i>
                            <i class="nucfont inuc-delete"
                                :title="$t('c.delete')"
                                @click="handleDelete(scope.row.id,0,1)"></i>
                        </div>
                    </el-table-column>
                </data-tables>
            </el-tab-pane>

            <el-tab-pane :label="$t('c.trainingType')">

                <data-tables class="form-table"
                        :data="trainTableData"
                        :table-props="tableProps"
                        :page-size="20"
                        :pagination-props="{pageSizes: [20, 50, 100, 300, 500]}"
                >
                    <el-table-column type="index" width="50" align="center"></el-table-column>

                    <!-- column title -->
                    <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label" :key="title.label"
                            align="center"
                            sortable="custom">
                    </el-table-column>

                    <!-- column buttons -->

                    <el-table-column :label="$t('c.operation')" align="center">
                        <div class="btn-cell" slot-scope="scope">
                            <i class="nucfont inuc-edit"
                                :title="$t('c.edit')"
                                @click="handleEdit(scope.row.id,0,1)"></i>
                            <i class="nucfont inuc-delete"
                                :title="$t('c.delete')"
                                @click="handleDelete(scope.row.id,0,1)"></i>
                        </div>
                    </el-table-column>
                </data-tables>
            </el-tab-pane>

            <el-tab-pane :label="$t('c.position')">
                <data-tables class="form-table"
                        :data="positionTableData"
                        :table-props="tableProps"
                        :page-size="20"
                        :pagination-props="{pageSizes: [20, 50, 100, 300, 500]}"
                >
                    <el-table-column type="index" width="50" align="center"></el-table-column>

                    <!-- column title -->
                    <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label" :key="title.label"
                                    align="center"
                                    sortable="custom">
                    </el-table-column>

                    <!-- column buttons -->

                    <el-table-column :label="$t('c.operation')" align="center">
                        <div class="btn-cell" slot-scope="scope">
                            <i class="nucfont inuc-edit"
                                :title="$t('c.edit')"
                                @click="handleEdit(scope.row.id,0,1)"></i>
                            <i class="nucfont inuc-delete"
                                :title="$t('c.delete')"
                                @click="handleDelete(scope.row.id,0,1)"></i>
                        </div>
                    </el-table-column>
                </data-tables>
            </el-tab-pane>

            <el-tab-pane :label="$t('system.theoryKnowledge')">
                <data-tables  class="form-table"
                            :data="knowledgeTableData"
                            :table-props="tableProps"
                            :page-size="20"
                            :pagination-props="{pageSizes: [20, 50, 100, 300, 500]}"
                            @expand-change="knowledgeExpandChange"
                >

                    <el-table-column type="index" width="50" align="center"></el-table-column>

                    <!-- expand -->
                    <el-table-column type="expand">
                        <template slot-scope="props">
                            <div class="expand-box">

                                <data-tables class="expand-table"
                                            :data="knowledgeSubData[props.row.id]"
                                            :table-props="{showHeader:false,border:false,stripe:false}"
                                            :show-header="false"
                                            :page-size="20"
                                            :pagination-props="{pageSizes: [20, 50, 100, 300, 500]}"
                                >
                                    <!-- column title -->
                                    <el-table-column width="50">
                                    </el-table-column>
                                    <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label"
                                                    :key="title.label"
                                                    align="center">
                                    </el-table-column>
                                    <!-- column buttons -->
                                    <el-table-column :label="$t('c.operation')" align="center">
                                        <div class="btn-cell" slot-scope="scope">
                                            <i class="nucfont inuc-edit"
                                                :title = "$t('c.edit')"
                                                @click = "handleEdit(scope.row.id, scope.row.superiorID,2)"></i>
                                            <i class = "nucfont inuc-delete"
                                                :title = "$t('c.delete')"
                                                @click = "handleDelete(scope.row.id, scope.row.superiorID,2)"></i>
                                        </div>
                                    </el-table-column>
                                </data-tables>
                            </div>
                        </template>
                    </el-table-column>

                    <!-- column title -->
                    <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label" :key="title.label"
                                    align="center"
                                    sortable="custom">
                    </el-table-column>

                    <!-- column buttons -->
                    <el-table-column :label="$t('c.operation')" align="center">
                        <div class="btn-cell" slot-scope="scope">
                            <i class="nucfont inuc-add-circle"
                                :title="$t('system.addSubmenu')"
                                @click="handleAdd(scope.row.id,1)"></i>
                            <i class="nucfont inuc-edit"
                                :title="$t('c.edit')"
                                @click="handleEdit(scope.row.id,0,1)"></i>
                            <i class="nucfont inuc-delete"
                                :title="$t('c.delete')"
                                @click="handleDelete(scope.row.id,0,1)"></i>
                        </div>
                    </el-table-column>
                </data-tables>
            </el-tab-pane>
            <el-tab-pane :label="$t('system.preJobApproval')">

                <data-tables class="form-table"
                            :data="preJobTableData"
                            :table-props="tableProps"
                            :page-size="20"
                            :pagination-props="{pageSizes: [20, 50, 100, 300, 500]}"
                >
                    <el-table-column type="index" width="50" align="center">
                    </el-table-column>
                    <!-- column title -->
                    <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label" :key="title.label"
                                    align="center"
                                    sortable="custom">
                    </el-table-column>

                    <!-- column buttons -->
                    <el-table-column :label="$t('c.operation')" align="center">
                        <div class="btn-cell" slot-scope="scope">
                            <i class="nucfont inuc-edit"
                                :title="$t('c.edit')"
                                @click="handleEdit(scope.row.id,0,1)"></i>
                            <i class="nucfont inuc-delete"
                                :title="$t('c.delete')"
                                @click="handleDelete(scope.row.id,0,1)"></i>
                        </div>
                    </el-table-column>
                </data-tables>
            </el-tab-pane>
            <el-tab-pane :label="$t('system.projectType')">

                <data-tables class="form-table"
                            :data="ledgerTableData"
                            :table-props="tableProps"
                            :page-size="20"
                            :pagination-props="{pageSizes: [20, 50, 100, 300, 500]}"
                >
                    <el-table-column type="index" width="50" align="center"></el-table-column>

                    <!-- column title -->
                    <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label" :key="title.label"
                                    align="center"
                                    sortable="custom">
                    </el-table-column>

                    <!-- column buttons -->

                    <el-table-column :label="$t('c.operation')" align="center">
                        <div class="btn-cell" slot-scope="scope">
                            <i class="nucfont inuc-edit"
                                :title="$t('c.edit')"
                                @click="handleEdit(scope.row.id,0,1)"></i>
                            <i class="nucfont inuc-delete"
                                :title="$t('c.delete')"
                                @click="handleDelete(scope.row.id,0,1)"></i>
                        </div>
                    </el-table-column>
                </data-tables>
            </el-tab-pane>
            <el-tab-pane :label="$t('train.absentReason')">

                <data-tables class="form-table"
                            :data="absenceTableData"
                            :table-props="tableProps"
                            :page-size="20"
                            :pagination-props="{pageSizes: [20, 50, 100, 300, 500]}"
                >
                    <el-table-column type="index" width="50" align="center"></el-table-column>

                    <!-- column title -->
                    <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label" :key="title.label"
                                    align="center"
                                    sortable="custom">
                    </el-table-column>

                    <!-- column buttons -->

                    <el-table-column :label="$t('c.operation')" align="center">
                        <div class="btn-cell" slot-scope="scope">
                            <i class="nucfont inuc-edit"
                                :title="$t('c.edit')"
                                @click="handleEdit(scope.row.id,0,1)"></i>
                            <i class="nucfont inuc-delete"
                                :title="$t('c.delete')"
                                @click="handleDelete(scope.row.id,0,1)"></i>
                        </div>
                    </el-table-column>
                </data-tables>
            </el-tab-pane>
            <el-tab-pane :label="$t('system.imageKnowledge')">
                <data-tables  class="form-table"
                        :data="imageKnowledgeTableData"
                        :table-props="tableProps"
                        :page-size="20"
                        :pagination-props="{pageSizes: [20, 50, 100, 300, 500]}"
                        @expand-change="knowledgeExpandChange"
                >

                    <el-table-column type="index" width="50" align="center"></el-table-column>

                    <!-- expand -->
                    <el-table-column type="expand">
                        <template slot-scope="props">
                            <div class="expand-box">

                                <data-tables class="expand-table"
                                        :data="imageKnowledgeSubData[props.row.id]"
                                        :table-props="{showHeader:false,border:false,stripe:false}"
                                        :show-header="false"
                                        :page-size="20"
                                        :pagination-props="{pageSizes: [20, 50, 100, 300, 500]}"
                                        @expand-change="knowledgeSubExpandChange"
                                >
                                    <!-- column title -->
                                    <el-table-column width="50">
                                    </el-table-column>
                                    <el-table-column type="expand">
                                        <template slot-scope="props">
                                            <div class="expand-box">

                                                <data-tables class="expand-table"
                                                        :data="imageKnowledgeSubSubData[props.row.id]"
                                                        :table-props="{showHeader:false,border:false,stripe:false}"
                                                        :show-header="false"
                                                        :page-size="20"
                                                        :pagination-props="{pageSizes: [20, 50, 100, 300, 500]}"
                                                >
                                                    <!-- column title -->
                                                    <el-table-column width="50">
                                                    </el-table-column>
                                                    <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label"
                                                            :key="title.label"
                                                            align="center">
                                                    </el-table-column>
                                                    <!-- column buttons -->
                                                    <el-table-column :label="$t('c.operation')" align="center">
                                                        <div class="btn-cell" slot-scope="scope">
                                                            <i class="nucfont inuc-edit"
                                                                :title="$t('c.edit')"
                                                                @click="handleEdit(scope.row.id, scope.row.superiorID,3)"></i>
                                                            <i class="nucfont inuc-move"
                                                                :title="$t('system.move')"
                                                                @click="handleMove(scope.row, scope.row.superiorID,3)"></i>
                                                            <i class="nucfont inuc-delete"
                                                                :title="$t('c.delete')"
                                                                @click="handleDelete(scope.row.id, scope.row.superiorID,3)"></i>
                                                        </div>
                                                    </el-table-column>
                                                </data-tables>
                                            </div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label"
                                            :key="title.label"
                                            align="center">
                                    </el-table-column>
                                    <!-- column buttons -->
                                    <el-table-column :label="$t('c.operation')" align="center">
                                        <div class="btn-cell" slot-scope="scope">
                                             <i class="nucfont inuc-add-circle"
                                                :title="$t('system.addSubmenu')"
                                                @click="handleAdd(scope.row.id,3)"></i>
                                            <i class="nucfont inuc-edit"
                                                :title="$t('c.edit')"
                                                @click="handleEdit(scope.row.id, scope.row.superiorID,2)"></i>
                                            <i class="nucfont inuc-move"
                                                :title="$t('system.move')"
                                                @click="handleMove(scope.row, scope.row.superiorID,2)"></i>
                                            <i class="nucfont inuc-delete"
                                                :title="$t('c.delete')"
                                                @click="handleDelete(scope.row.id, scope.row.superiorID,2)"></i>
                                        </div>
                                    </el-table-column>
                                </data-tables>
                            </div>
                        </template>
                    </el-table-column>

                    <!-- column title -->
                    <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label" :key="title.label"
                            align="center"
                            sortable="custom">
                    </el-table-column>

                    <!-- column buttons -->
                    <el-table-column :label="$t('c.operation')" align="center">
                        <div class="btn-cell" slot-scope="scope">
                            <i class="nucfont inuc-add-circle"
                                :title="$t('system.addSubmenu')"
                                @click="handleAdd(scope.row.id,1)"></i>
                            <i class="nucfont inuc-edit"
                                :title="$t('c.edit')"
                                @click="handleEdit(scope.row.id,0,1)"></i>
                            <i class="nucfont inuc-delete"
                                :title="$t('c.delete')"
                                @click="handleDelete(scope.row.id,0,1)"></i>
                        </div>
                    </el-table-column>
                </data-tables>
            </el-tab-pane>
            <el-tab-pane :label="$t('res.knowType')">

                <data-tables class="form-table"
                        :data="assetTableData"
                        :table-props="tableProps"
                        :page-size="20"
                        :pagination-props="{pageSizes: [20, 50, 100, 300, 500]}"
                >
                    <el-table-column type="index" width="50" align="center">
                    </el-table-column>
                    <!-- column title -->
                    <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label" :key="title.label"
                            align="center"
                            sortable="custom">
                    </el-table-column>

                    <!-- column buttons -->
                    <el-table-column :label="$t('c.operation')" align="center">
                        <div class="btn-cell" slot-scope="scope">
                            <i class="nucfont inuc-edit"
                                :title="$t('c.edit')"
                                @click="handleEdit(scope.row.id,0,1)"></i>
                            <i class="nucfont inuc-delete"
                                :title="$t('c.delete')"
                                @click="handleDelete(scope.row.id,0,1)"></i>
                        </div>
                    </el-table-column>
                </data-tables>
            </el-tab-pane>
            <el-tab-pane :label="$t('topic.answerLabelType')">
                <data-tables  class="form-table"
                            :data="answerTableData"
                            :table-props="tableProps"
                            :page-size="20"
                            :pagination-props="{pageSizes: [20, 50, 100, 300, 500]}"
                            @expand-change="knowledgeExpandChange"
                >
                    <el-table-column type="index" width="50" align="center"></el-table-column>

                    <!-- expand -->
                    <el-table-column type="expand">
                        <template slot-scope="props">
                            <div class="expand-box">

                                <data-tables class="expand-table"
                                            :data="answerSubData[props.row.id]"
                                            :table-props="{showHeader:false,border:false,stripe:false}"
                                            :show-header="false"
                                            :page-size="20"
                                            :pagination-props="{pageSizes: [20, 50, 100, 300, 500]}"
                                >
                                    <!-- column title -->
                                    <el-table-column width="50">
                                    </el-table-column>
                                    <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label"
                                                    :key="title.label"
                                                    align="center">
                                    </el-table-column>
                                    <!-- column buttons -->
                                    <el-table-column :label="$t('c.operation')" align="center">
                                        <div class="btn-cell" slot-scope="scope">
                                            <i class="nucfont inuc-edit"
                                                :title = "$t('c.edit')"
                                                @click = "handleEdit(scope.row.id, scope.row.superiorID,2)"></i>
                                            <i class = "nucfont inuc-delete"
                                                :title = "$t('c.delete')"
                                                @click = "handleDelete(scope.row.id, scope.row.superiorID,2)"></i>
                                        </div>
                                    </el-table-column>
                                </data-tables>
                            </div>
                        </template>
                    </el-table-column>

                    <!-- column title -->
                    <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label" :key="title.label"
                                    align="center"
                                    sortable="custom">
                    </el-table-column>

                    <!-- column buttons -->
                    <el-table-column :label="$t('c.operation')" align="center">
                        <div class="btn-cell" slot-scope="scope">
                            <i class="nucfont inuc-add-circle"
                                :title="$t('system.addSubmenu')"
                                @click="handleAdd(scope.row.id,1)"></i>
                            <i class="nucfont inuc-edit"
                                :title="$t('c.edit')"
                                @click="handleEdit(scope.row.id,0,1)"></i>
                            <i class="nucfont inuc-delete"
                                :title="$t('c.delete')"
                                @click="handleDelete(scope.row.id,0,1)"></i>
                        </div>
                    </el-table-column>
                </data-tables>
            </el-tab-pane>
        </el-tabs>

        <el-dialog
            :title="dialogTitle"
            :visible.sync="dialogFormVisible"
            width="450px"
            :close-on-click-modal="false"
            :modal-append-to-body="false">
            <el-form
                :model="dialogForm"
                :rules="formRules"
                class="dialogForm"
                ref="dialogForm"
                @submit.native.prevent
                label-width="100px">
                <el-form-item :label="$t('c.name')" prop="value">
                    <el-input v-model="dialogForm.value" auto-complete="off" :placeholder="$t('tip.name')" clearable></el-input>
                </el-form-item>
                <el-form-item :label="$t('system.remark')" prop="remark">
                    <el-input
                        type="textarea"
                        :rows="2"
                        :placeholder="$t('tip.remark')"
                        v-model="dialogForm.remark" clearable>
                    </el-input>
                </el-form-item>
                <input type="hidden" :value="dialogForm.superiorID">
            </el-form>
            <div slot="footer" style="text-align: center;">
                <el-button type="primary" @click="dialogSave('dialogForm')" :loading="saveLoading">{{$t('c.save')}}</el-button>
            </div>
        </el-dialog>
        <el-dialog :title="$t('system.move')"
                :visible.sync="dialogTreeMove"
                width="510px"
                :close-on-click-modal="true"
                :modal-append-to-body="false">
            <p class="choose-tip"><span class="nucfont inuc-exclamation-circle"></span> {{$t('tip.knowledgePoint')}}</p>
            <el-tree
                    ref="moveTree"
                    :data="moveTreeData"
                    node-key="id"
                    :props="defaultProps"
                    @node-click="chooseNode"
                    >
                    
                </el-tree>
            <p class="node-selected">{{$t('system.selected')}}：{{dialogNodePosition.join(' / ')}}</p>
            <div slot="footer" style="text-align: center; margin-top: -10px;">
                <el-button type="primary" :disabled="!nodeSelected.id" :loading="moveLoading"  @click="saveMove">{{$t('c.save')}}</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import api from '@/api';
    import {mapGetters} from 'vuex'

    export default {
        data() {
            return {
                dialogTitle: this.$t('c.add'),
                tabIndex: 0,
                levelTableData: [],
                preJobTableData: [],
                testTableData: [],
                trainTableData: [],
                positionTableData: [],
                knowledgeTableData: [],
                knowledgeSubData: [],
                imageKnowledgeTableData: [],
                imageKnowledgeSubData: [],
                imageKnowledgeSubSubData: [],
                ledgerTableData: [],
                absenceTableData: [],
                assetTableData: [],
                answerTableData: [],
                answerSubData: [],
                dialogFormVisible: false,
                dialogForm: {
                    id: null,
                    value: '',
                    remark: '',
                    superiorID: ''
                },
                dataLevel:0,
                formRules: {
                    value: [
                        {required: true, message: this.$t('tip.name'), trigger: 'blur'},
                        {max: 50, message: this.$t('rule.maxLength', ['50']), trigger: 'blur'}
                    ],
                    remark: [
                        {max: 100, message: this.$t('rule.maxLength', ['100']), trigger: 'blur'},
                    ],
                },
                saveLoading: false,
                tableProps: {
                    border: false,
                    stripe: true,
                    //height: "500"
                },
                titles: [
                    {
                        prop: 'value',
                        label: this.$t('c.name')
                    }, {
                        prop: 'remark',
                        label: this.$t('system.remark')
                    }, {
                        prop: 'createTime',
                        label: this.$t('c.creationTime')
                    }, {
                        prop: 'modifyTime',
                        label: this.$t('c.modificationTime')
                    }
                ],
                dialogTreeMove: false,
                nodeSelected: {
                    id: '',
                    name: ''
                },
                moveLoading: false,
                moveTreeData: [],
                dialogNodePosition: [],
                defaultProps: {
                    children: 'children',
                    label: 'value'
                },
                tab: ['Grad', 'AssessMethod', 'TrainingType', 'Post', 'Knowledge', 'PreJobApproval', 'StandingBookProjectType', 'AbsentCause', 'ImageKnowledge', 'AssetCategory','AnswerKnowledge'],
            }
        },
        created() {
            this.query();
        },
        methods: {
            query() {
                api.getDictionaryQuery(this.tab[this.tabIndex]).then((res) => {
                    let data = res.package;
                    data.forEach(item => {
                        item.remark = item.remark || '';
                        item.createTime = item.createTime?item.createTime.substring(0, 10):'';
                        item.modifyTime = item.modifyTime?item.modifyTime.substring(0, 10):'';
                    });
                    this.levelTableData = data;
                    switch (this.tabIndex) {
                        case '0':
                            this.levelTableData = data;
                            break;
                        case '1':
                            this.testTableData = data;
                            break;
                        case '2':
                            this.trainTableData = data;
                            break;
                        case '3':
                            this.positionTableData = data;
                            break;
                        case '4':
                            this.knowledgeTableData = data;
                            break;
                        case '5':
                            this.preJobTableData = data;
                            break;
                        case '6':
                            this.ledgerTableData = data;
                            break;
                        case '7':
                            this.absenceTableData = data;
                            break;
                        case '8':
                            // 当是空包时删除
                            let idx = data.findIndex(v=>v.id == 23)
                            if(idx > -1){
                                data.splice(idx,1)
                            }
                            this.imageKnowledgeTableData = data;
                            break;
                        case '9':
                            this.assetTableData = data;
                            break;
                        case '10':
                            this.answerTableData = data;
                            break;
                    }
                });
            },
            handleMove(data, supID, level){
                this.dialogForm.id = data.id
                this.dialogForm.value = data.value
                this.dialogTreeMove = true
                this.dialogNodePosition = []
                this.nodeSelected.id = ''
                this.nodeSelected.name = ''
                api.getImageKpSuperiorTree().then(res => {
                    this.moveTreeData = res.package
                    this.moveTreeData.forEach(item =>{
                        if(level==2){
                            item.children = []
                        }else if(level==3){
                            if(item.children.length>0){
                                item.children.forEach(itm => {
                                    itm.children = []
                                })
                            }
                        }
                    })
                })
                if (supID) {
                    this.dialogForm.superiorID = supID;
                } else {
                    delete this.dialogForm.superiorID;
                }
                if(level){
                    this.dataLevel = level
                }

            },

            handleClick(tab, event) {
                this.tabIndex = tab.index;
                this.query();
            },
            handleAdd(supID,level){
                this.dialogFormVisible = true;
                this.$refs['dialogForm'] && this.$refs['dialogForm'].resetFields();
                this.dialogForm.id = null;
                this.dialogForm.value = null;
                this.dialogTitle = this.$t('c.add');

                if (supID) {
                    this.dialogForm.superiorID = supID;
                } else {
                    delete this.dialogForm.superiorID;
                }
                if(level){
                    this.dataLevel = level
                }
            },

            handleEdit(id, supID,level) {
                this.dialogTitle = this.$t('c.edit');
                this.dialogFormVisible = true;

                api.getDictionary(this.tab[this.tabIndex], id).then((res) => {
                    this.dialogForm.id = res.package.id;
                    this.dialogForm.value = res.package.value;
                    this.dialogForm.remark = res.package.remark;
                });

                if (supID) {
                    this.dialogForm.superiorID = supID;
                } else {
                    delete this.dialogForm.superiorID;
                }
                if(level){
                    this.dataLevel = level
                }
            },
            handleDelete(id, supID,level) {
                this.$confirm(this.$t('m.delete'), this.$t('m.tip'), {
                    type: 'warning'
                }).then(() => {
                    api.deletDictionary(this.tab[this.tabIndex], id).then((res) => {
                        this.success(this.$t('m.delSuccess'));
                        if (supID) {
                            if(level == 3){
                                this.querySubSubKnowledge(supID);
                            }else{
                                this.querySubKnowledge(supID);
                            }
                        } else {
                            this.query();
                        }
                    });
                }).catch(() => {});
            },
            dialogSave(formName){
                this.$refs[formName].validate((valid) => {
                    if (!valid) return;
                    this.saveLoading = true;
                    if (this.dialogForm.value && this.dialogForm.id) {
                        api.editDictionary(this.tab[this.tabIndex], this.dialogForm.id, this.dialogForm).then((res) => {
                            this.dialogFormVisible = false;
                            this.saveLoading = false;
                            this.success(this.$t('m.editSuccess'));
                            if (this.dialogForm.superiorID) {
                                if(this.dataLevel == 3){
                                    this.querySubSubKnowledge(this.dialogForm.superiorID);
                                }else{
                                    this.querySubKnowledge(this.dialogForm.superiorID);
                                }
                                // this.querySubKnowledge(this.dialogForm.superiorID);
                            } else {
                                this.query();
                            }
                        }).catch(error => this.saveLoading = false);
                    } else {
                        api.addDictionary(this.tab[this.tabIndex], this.dialogForm).then((res) => {
                            this.dialogFormVisible = false;
                            this.saveLoading = false;
                            this.success(this.$t('m.addSuccess'));
                            if (this.dialogForm.superiorID) {

                                if(this.dataLevel == 3){
                                    this.querySubSubKnowledge(this.dialogForm.superiorID);
                                }else{
                                    this.querySubKnowledge(this.dialogForm.superiorID);
                                }
                            } else {
                                this.query();
                            }
                        }).catch(error => this.saveLoading = false);
                    }
                });
            },

            //选择移动页面
            chooseNode(data, node) {
                this.nodeSelected.id = data.id
                this.nodeSelected.name = data.value
                this.dialogNodePosition = []
                this.getDialogParentNode(node)
            },
            //保存移动
            saveMove() {
                this.moveLoading = true
                let data ={
                    id: this.dialogForm.id,
                    value:this.dialogForm.value,
                    SuperiorID: this.nodeSelected.id
                }
                api.editDictionary(this.tab[this.tabIndex],  this.dialogForm.id , data).then((res) => {
                    this.dialogTreeMove = false;
                    this.moveLoading = false;
                    this.success(this.$t('res.moveSuccess'))
                    // if (this.dialogForm.superiorID) {
                    //     if(this.dataLevel == 3){
                    //         this.querySubSubKnowledge(this.dialogForm.superiorID);
                    //     }else{
                    //         this.querySubKnowledge(this.dialogForm.superiorID);
                    //     }
                    //     // this.querySubKnowledge(this.dialogForm.superiorID);
                    // } else {
                        this.query();
                    // }
                }).catch(error => this.moveLoading = false);
            },
            //获取dialog节点父级
            getDialogParentNode(node){
                if (node) {
                    if (node.parent) {
                        // if(node.data.type == 3){
                        //     this.dialogNodePosition.unshift(this.$t('res.shareFrom',{share: node.data.value}))
                        // }else{
                            this.dialogNodePosition.unshift(node.data.value) //在数组头部添加元素
                        // }
                        this.getDialogParentNode(node.parent) //递归
                    }
                }
            },

            querySubKnowledge(id) {
                let kpName = ''

                if(this.tabIndex == 8){
                    kpName = 'ImageKnowledge'
                } else if(this.tabIndex == 10){
                    kpName = 'AnswerKnowledge'
                } else if(this.tabIndex == 4){
                    kpName = 'Knowledge'
                }
                api.getDictionaryQuery(kpName, {
                    superiorId: id
                }).then(res => {
                    let data = res.package;
                    if (data.length) {
                        data.forEach(item => {
                            item.createTime = item.createTime?item.createTime.substring(0, 10):'';
                            item.modifyTime = item.modifyTime?item.modifyTime.substring(0, 10):'';
                        });
                    }
                    if(this.tabIndex == 8){
                        this.$set(this.imageKnowledgeSubData, id, data)
                    } else if(this.tabIndex == 10){
                        this.$set(this.answerSubData, id, data)
                    } else if(this.tabIndex == 4){
                        this.$set(this.knowledgeSubData, id, data)
                    }
                })
            },
            querySubSubKnowledge(id) {
                let kpName = ''

                kpName = 'ImageKnowledge'
                api.getDictionaryQuery(kpName, {
                    superiorId: id
                }).then(res => {
                    let data = res.package;
                    if (data.length) {
                        data.forEach(item => {
                            item.createTime = item.createTime?item.createTime.substring(0, 10):'';
                            item.modifyTime = item.modifyTime?item.modifyTime.substring(0, 10):'';
                        });
                    }
                    this.$set(this.imageKnowledgeSubSubData, id, data)
                })
            },
            knowledgeExpandChange(row) {
                this.querySubKnowledge(row.id)
            },
            knowledgeSubExpandChange(row) {
                this.querySubSubKnowledge(row.id)
            },

            success(msg) {
                this.$message({
                    message: msg,
                    type: 'success'
                })
            },
        },
        computed: {},
        watch: {},
        components: {}
    }
</script>

<style scoped lang="scss">
    .page-operate {
        margin-bottom: 10px;
    }

    .dialogForm {
        margin-right: 40px;
    }

    .expand-box {
        margin: -20px -50px;
        font-size: 12px;
    }
    .choose-tip{
        color: #00bcd4;
        margin: 1px 10px 15px 10px;
        font-size: 13px;
        .nucfont{
            font-size:12px
        }
    }
    .node-selected{
        margin-top: 15px;
        margin-left: 10px;
        margin-bottom: 10px;
        color : #999;
    }
</style>
<style lang="scss">
    .dictionaryPage {

        tr {
            font-size: 15px;
            color: #333;
        }

        .expand-table {
            tr {
                font-size: 13px;
                color: #666;
            }

            td:nth-child(2) .cell {
                padding-right: 65px;
                text-align: right;
            }

            .pagination-bar {
                display: none;
            }
        }

    }
</style>
